import { Button } from "@/components/ui/button";
import { Instagram, Linkedin, ArrowRight, Sparkles } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
const Contact = () => {
  return (
    <section id="contact" className="py-24 md:py-32 relative overflow-hidden">
      {/* Matrix-inspired background */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-background"></div>
      
      {/* Animated gradient orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-accent/20 rounded-full blur-[100px] animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/20 rounded-full blur-[100px] animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      {/* Grid texture */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `linear-gradient(to right, hsl(var(--foreground)) 1px, transparent 1px),
                          linear-gradient(to bottom, hsl(var(--foreground)) 1px, transparent 1px)`,
        backgroundSize: '50px 50px'
      }}></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-12 animate-fade-in">
            <SectionHeader
              badge="Bereit für Ihre Story?"
              title="Lassen Sie uns gemeinsam starten"
              highlightedWord="gemeinsam"
              description="Ob mit Kamera oder KI – wir finden die perfekte Lösung für Ihre Marke und bringen Ihre Vision zum Leben."
              className="mb-12"
            />
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            <Button 
              className="group bg-accent md:hover:bg-accent/90 text-black font-bold text-sm md:text-base px-5 py-2.5 md:px-6 md:py-3 rounded-lg shadow-[0_0_20px_rgba(134,239,172,0.3)] md:hover:shadow-[0_0_30px_rgba(134,239,172,0.5)] transition-all duration-300"
              onClick={() => window.location.href = '/termin'}
            >
              <span className="font-bold">Projekt starten</span>
              <ArrowRight className="ml-1.5 w-4 h-4 md:group-hover:translate-x-1 transition-transform" />
            </Button>
            
            <Button 
              variant="outline"
              className="group border-2 border-accent/30 md:hover:border-accent md:hover:bg-accent/5 text-foreground font-semibold text-sm md:text-base px-5 py-2.5 md:px-6 md:py-3 rounded-lg transition-all duration-300"
              onClick={() => document.getElementById('work')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Arbeiten ansehen
            </Button>
          </div>

          {/* Contact Info */}
          <div className="animate-fade-in pt-8 border-t border-border/30" style={{ animationDelay: '0.4s' }}>
            <p className="text-muted-foreground mb-4">
              Oder kontaktieren Sie uns direkt
            </p>
            <a 
              href="mailto:hello@aivinity.de" 
              className="text-xl md:text-2xl font-semibold text-accent hover:text-accent/80 transition-colors"
            >
              hello@aivinity.de
            </a>
            <p className="text-muted-foreground mt-2">
              <a href="tel:+4915772982459" className="hover:text-foreground transition-colors">
                +49 (0) 1577 2982459
              </a>
            </p>
          </div>

          {/* Social Media */}
          <div className="flex justify-center gap-6 mt-12 animate-fade-in" style={{ animationDelay: '0.6s' }}>
            <a
              href="https://instagram.com/jcproductions.de"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Folge uns auf Instagram"
              className="group flex items-center justify-center w-12 h-12 rounded-full bg-card/50 border border-border/50 md:hover:border-accent/50 md:hover:bg-accent/5 transition-all duration-300"
            >
              <Instagram className="w-5 h-5 text-muted-foreground md:group-hover:text-accent transition-colors" />
            </a>
            <a
              href="https://www.linkedin.com/in/janclassen/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Verbinde dich auf LinkedIn"
              className="group flex items-center justify-center w-12 h-12 rounded-full bg-card/50 border border-border/50 md:hover:border-accent/50 md:hover:bg-accent/5 transition-all duration-300"
            >
              <Linkedin className="w-5 h-5 text-muted-foreground md:group-hover:text-accent transition-colors" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
